import InputRichText from '@components/InputRichText';
import { useFormContext } from 'react-hook-form';

const JobOfferMissionForm = () => {
    const { control } = useFormContext();

    return (
        <InputRichText
            label="Missions (minimum 50 caractères)"
            control={control}
            name="description.missions"
            placeholder="Décrivez ici la mission que votre futur(e) salarié(e) aura à réaliser dans le cadre de son emploi. Penser à mettre en évidence les points capitaux pour vous, par exemple, l'autonomie, le management, l'ambiance du salon etc ..."
            required
            defaultValue={undefined}
        />
    );
};

export default JobOfferMissionForm;
